const dsColors = {
  black: '#000000',

  grey50percent: '#0d172480',
  white: '#FFFFFF',
  success: '#019F3C',
  successBackground: '#E6F5EC',
  warning: '#F29100',
  warningBackground: '#FEF4E6',
  danger: '#D91528',
  dangerBackground: '#FBE8EA',
  link: '#0055FF',

  // DS colors
  systemDark100: '#D0D4DC',
  systemDark200: '#445371',
  systemDark200aCC: '#445371CC',
  systemDark200a33: '#44537133',
  systemDark200a1A: '#4453711A',
  systemDark200a0D: '#4453710d',
  systemDark300: '#000430',
  systemDark80A: '#000430CC',
  systemDark50A: '#00043029',

  systemFlame100: '#FBE8EA',
  systemFlame200: '#D91528',
  systemFlame300: '#980F1C',

  systemForest100: '#E6F5EC',
  systemForest200: '#019F3C',

  systemLight50: '#FFFFFF29',
  systemLight100: '#FFFFFF',
  systemLight200: '#F4F7FB',
  systemLight300: '#EAEDF1',

  systemSky100: '#E6EEFF',
  systemSky200: '#0055FF',
  systemSky300: '#003BB3',

  systemSun100: '#FEF4E6',
  systemSun200: '#F29100',

  systemNavy100: '#F0EEFE',
  systemNavy200: '#6952F5',
  systemNavy300: '#4939AC',

  systemGold100: '#E8E5DB',
  systemGold300: '#6A5D39',

  systemMint100: '#E6F7F3',
  systemMint200: '#00B288',
  systemMint300: '#007D5F',

  systemTeal100: '#E7F4F8',
  systemTeal200: '#1192BB',
  systemTeal300: '#0C6683',
};

export const COLORS = {
  ...dsColors,

  listItemHoverBg: dsColors.systemLight200,

  colorLink: '#00043099',
  colorLinkHover: '#000430',
  colorLinkActive: '#000430a3',

  colorIcon: '#000430a3',
  colorIconHover: '#26251C',

  colorPrimaryText: '#000430',
  colorPrimaryTextActive: '#0f1723cc',
  colorPrimaryTextHover: '#0f1723cc',

  colorTextBase: '#0F1723',
  colorTextSecondary: '#2F4F7C',
  colorTextTertiary: '#2F4F7C',
  colorTextQuaternary: '#2F4F7C',

  colorCardShadow: '#1110141a',
  colorBgBase: '#FFFFFF',
  colorBgLayout: '#FFFFFF',
  colorBgSpotlight: '#17150D',
  controlItemBgHover: '#0004303d',
  controlItemBgActive: '#0004301f',
  controlItemBgActiveHover: '#2F4F7C',

  colorPrimaryActive: '#000430',
  colorPrimary: '#000430',
  colorPrimaryHover: '#000430cc',
  colorPrimaryBorder: '#0004301f',
  colorPrimaryBorderFocus: '#000430cc',
  colorPrimaryBorderHover: '#000430cc',

  colorPrimaryBg: dsColors.systemLight200,
  colorPrimaryBgHover: '#0004301f',

  colorBgContainer: '#FFFFFF',

  colorFillContent: '#0004301f',
  colorTextDescription: '#000430a3',
  colorNeutral: '#595956',
  colorNeutral2: '#F2F2EB',
  colorBorder: '#0004301f',

  colorSelectActiveOption: dsColors.systemSky100,

  colorButton: '#0D1724',

  colorGoldBg: '#FFFBE6',
  colorGoldBorder: '#FFE58F',

  colorInputIcon: dsColors.systemDark200,
  colorSubtitle: dsColors.systemDark200,

  error: '#FF4D4F',

  colorIwSwitchBg: dsColors.systemDark100,
  colorIwSectionTitle: '#060136',
  colorIwBannerOverlay: '#00000065',
  colorIwLoaderOverlay: '#ffffff08',
  colorIwBorder: '#D9D9D9',
  colorIwRecordButton: '#ffffff1a',

  colorFilePreviewBg: '#5e5e5e',

  colorDemoCharts: ['#5AC2F7', '#1676F3', '#FF7D94', '#C5164E', '#15C15D'],
  colorDirectAssetsCharts: ['#1676F3', '#FF7D94'],
  colorAssetDistributionCharts: ['#5AC2F7', '#1676F3', '#FF7D94', '#C5164E', '#15C15D'],
  colorVfoTags: ['#5AC2F7', '#1192BB', '#FF7D94', '#00B288', '#C18ED2', '#9233B3', '#FDA253'],

  colorVfoCases: [
    '#95A4E1',
    '#7FB4D3',
    '#718EAE',
    '#E7CE97',
    '#5F666C',
    '#9BB7C3',
    '#B3B5AA',
    '#8878B9',
  ],
  colorBeneficiariesStatusCharts: ['#1676F3', '#FDA253', '#019F3C'],
  colorVfoMyMessage: '#0055FF1A',
  colorVfoMessageHover: '#E6EEFFCC',

  colorPdfBorder: '#F3F3F3',
  statusTeal100: '#E7F4F8',
  statusTeal300: '#0C6683',
  colorWhite40A: '#ffffff66',
  colorWhite70A: '#ffffffb3',

  colorSky17A: '#0055FF2B',

  //#region Components
  mainLayoutBackground: dsColors.systemLight200,
  percentageBarBackground: '#8A7D6D',

  // New field colors sets
  colorFieldBg: dsColors.systemLight200,
  colorFiledDanger: dsColors.systemFlame200,
  colorFieldErrorBg: dsColors.systemFlame100,
  colorFieldLabel: dsColors.systemDark200,
  colorFieldText: dsColors.systemDark300,
  colorFieldHoverBg: dsColors.systemLight300,
  colorFieldBorder: dsColors.systemSky200,
  colorFieldOptionDivider: dsColors.systemDark100,
  colorFieldChipBg: dsColors.systemDark50A,
  colorFieldListBg: dsColors.systemLight100,

  control: {
    borderColor: '#d9d9d9',
    activeBorderColor: '#0a103d',
  },

  /**
   * @deprecated Use dsColors.systemDark100
   */
  grey: dsColors.systemDark100,
  /**
   * @deprecated Use dsColors.systemSky200
   */
  blueColor: dsColors.systemSky200,
  /**
   * @deprecated Use dsColors.systemLight300
   */
  light300: dsColors.systemLight300,

  scenarios: {
    ACTIVE: {
      background: dsColors.systemSun100,
      borderColor: dsColors.systemSun200,
      color: dsColors.systemSun200,
    },
    DONE: {
      background: dsColors.systemForest100,
      borderColor: dsColors.systemForest200,
      color: dsColors.systemForest200,
    },
    DRAFT: {
      background: dsColors.systemLight200,
      borderColor: dsColors.systemDark100,
      color: dsColors.systemDark300,
    },
    IN_PROGRESS: {
      background: dsColors.systemDark300,
      borderColor: dsColors.systemDark300,
      color: dsColors.systemLight100,
    },
  },

  /* */
  chartColors: [
    '#4CAF50',
    '#FFC107',
    '#2196F3',
    '#FF5722',
    '#9C27B0',
    '#00BCD4',
    '#FFEB3B',
    '#E91E63',
    '#795548',
    '#607D8B',
    // repeat TODO rework
    '#4CAF50',
    '#FFC107',
    '#2196F3',
    '#FF5722',
    '#9C27B0',
    '#00BCD4',
    '#FFEB3B',
    '#E91E63',
    '#795548',
    '#607D8B',
  ],
};
